import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../../../../../store';
import {
    AutoBroadcast,
    AutoBroadcastProps,
    AutoBroadcastValues,
} from '../service/autoBroadcast.interface';
import { autoBroadcastsApi } from '../service/autoBroadcasts.api';

const initialState = {
    settings: [] as AutoBroadcastValues[],
    current: null as AutoBroadcastProps,
};

export const autoBroadcastsSlice = createSlice({
    name: 'autoBroadcast',
    initialState,
    reducers: {
        setCurrent: (state, action) => {
            state.current = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addMatcher(
            autoBroadcastsApi.endpoints.readAutoBroadcast.matchFulfilled,
            (state, { payload }) => {
                state.settings = payload;
            }
        );
    },
});

export const selectAutoBroadcast = (state: RootState) => state.autoBroadcast;

export const { setCurrent } = autoBroadcastsSlice.actions;

export const selectAutoBroadcastByType = (
    state: RootState,
    type: AutoBroadcast
): AutoBroadcastValues | undefined =>
    state.autoBroadcast.settings.find(setting => setting.type === type);

export const autoBroadcastsReducer = autoBroadcastsSlice.reducer;
